/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface PersonInstitutionalIdDTO
 */
export interface PersonInstitutionalIdDTO  {
    /**
     * 
     * @type {number}
     * @memberof PersonInstitutionalIdDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PersonInstitutionalIdDTO
     */
    institution?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonInstitutionalIdDTO
     */
    value?: string;
}

/**
 * Check if a given object implements the PersonInstitutionalIdDTO interface.
 */
export function instanceOfPersonInstitutionalIdDTO(value: object): value is PersonInstitutionalIdDTO {
    return true;
}

export function PersonInstitutionalIdDTOFromJSON(json: any): PersonInstitutionalIdDTO {
    return PersonInstitutionalIdDTOFromJSONTyped(json, false);
}

export function PersonInstitutionalIdDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonInstitutionalIdDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'institution': json['institution'] == null ? undefined : json['institution'],
                  'value': json['value'] == null ? undefined : json['value'],
    };
}

export function PersonInstitutionalIdDTOToJSON(json: any): PersonInstitutionalIdDTO {
    return PersonInstitutionalIdDTOToJSONTyped(json, false);
}

export function PersonInstitutionalIdDTOToJSONTyped(value?: PersonInstitutionalIdDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'institution': value['institution'],
        'value': value['value'],
    };
}


